import Vue from 'vue';
import GameRoleSelect from './game-role-select.vue';
import ConfirmGameRole from './confirm-game-role.vue';

const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}

export default {
  showGameRoleSelect(gameCode, { context = null, defaultPartitionId, defaultRoleId, option } = {}) {
    // 业务login插件自定义角色选择框，平台统一调baseComponent.showGameRoleSelect
    const pluginName = getPluginName(Vue.prototype.$actInfo.ast, 'login');
    if (Vue.prototype?.[pluginName]?.showGameRoleSelect) {
      return Vue.prototype[pluginName].showGameRoleSelect(gameCode, {
        context,
        defaultPartitionId,
        defaultRoleId,
        option: Vue.prototype?.$storeInstance?.getters?.dialogConfig,
      });
    }
    return new Promise((resolve) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const GameRoleSelectCreator = Vue.extend(GameRoleSelect);

      const gameRoleSelect = new GameRoleSelectCreator({
        el: document.createElement('div'),
        created() {
          this.game_code = gameCode;
          this.options = {
            defaultPartitionId: defaultPartitionId || '',
            defaultRoleId: defaultRoleId || '',
          };
          this.option = option;
          this.$on('finish', (gameRoleInfo) => {
            this.$destroy();
            resolve(gameRoleInfo, this.$el);
          });

          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(gameRoleSelect.$el);
    });
  },
  showConfirmGameRole({
    context = null,
    gameCode,
    roleInfoObj,
    option,
  } = {}) {
    return new Promise((resolve) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const ConfirmGameRoleCreator = Vue.extend(ConfirmGameRole);

      const confirmGameRole = new ConfirmGameRoleCreator({
        el: document.createElement('div'),
        created() {
          this.gameCode = gameCode;
          this.roleInfoObj = roleInfoObj;
          this.option = option;

          this.$on('confirmReward', (roleInfo) => {
            this.$destroy();
            resolve(roleInfo);
          });
          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(confirmGameRole.$el);
    });
  },
};
